export interface IuseContentList {
    defaultSort?:string
    children:React.ReactNode
}

export interface PaginationSettings {
    hasPagination: boolean
    currentPage: number
    totalPages: number
    pageSize: number
    totalItems: number
}

export enum SortType {
    DateCreatedNewest = 1,
    DateCreatedOldest = 2,
    DateModifiedNewest = 3,
    DateModifiedOldest = 4,
    TitleAZ = 5,
    TitleZA = 6,
    Manual = 0,
}